import type { useRouter } from 'expo-router';
import type { RecipeIndexEntry } from '../services/unifiedRecipeService';
import { prefetchRecipe } from '../services/recipePrefetch';

type AppRouter = ReturnType<typeof useRouter>;

/**
 * Open the app's standard full recipe-detail page for a meal-planner recipe.
 * Passes `recipeData` (index fields) so the page renders instantly, then loads
 * the full recipe by id. `from: 'meal-planner'` lets the detail route send the
 * user back here. Mirrors how the Recipes tab opens a recipe.
 */
export function openRecipeDetail(router: AppRouter, recipe: RecipeIndexEntry) {
  // Asked for now, while the screen mounts; the screen's own read joins it (#874).
  prefetchRecipe(recipe.id);
  router.push({
    pathname: `/(app)/recipe-detail/${recipe.id}`,
    params: {
      recipeData: JSON.stringify({
        id: recipe.id,
        title: recipe.title,
        image: recipe.image,
        servings: recipe.servings,
        readyInMinutes: recipe.readyInMinutes,
        dishTypes: recipe.dishTypes,
        cuisines: recipe.cuisines,
        diets: recipe.diets,
        ingredients: recipe.ingredients,
        sourceUrl: recipe.sourceUrl,
      }),
      from: 'meal-planner',
    },
  });
}
